import type { CardHooks } from "./registry";

/**
 * Clobberation — on attack damage, +1 wear counter on opponent armor.
 * On full block (defend), grant Serrated to next attack (so when next attack
 * deals damage, +1 wear on opp armor via Serrated keyword handling).
 */
export const clobberation: CardHooks = {
  onFullBlock: (ctx) => ({
    selfPatch: {
      pendingBuffs: [
        ...ctx.self.pendingBuffs,
        {
          id: `cl_${Math.random().toString(36).slice(2, 9)}`,
          sourceCardName: "Clobberation",
          trigger: "next-attack",
          effect: { kind: "gain-serrated" },
          createdRound: ctx.game.round,
        },
      ],
    },
    log: ["Clobberation — full block, next attack gains Serrated"],
  }),
};
